export default "__VITE_ASSET__CWlL3WlR__"